import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-file-plus-icon',
  templateUrl: './files-file-plus.component.html'
})
export class FilesFilePlusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
